import React from "react";
import { Drawer, Box, IconButton } from "@mui/material";
import profilecross from "../../../../assets/profilecross.svg";
import CustomText, { textStyles } from "../../../../components/CustomText";
import PaidIcon from "@mui/icons-material/CheckCircle";
import VisibilityIcon from "@mui/icons-material/Visibility";
import down from "../../../../assets/down.svg";
import view from "../../../../assets/Wallet/view.png";
import MultiSelectDropdown from "../../../../components/MultiSelectionDropdown";
import StatusDropdown from "../../../../components/StatusDropdown";
import receipt from "../../../../assets/Wallet/receipt.svg";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import CustomButton from "../../../../components/CustomButton";
import { showUnderDevelopment } from "../../../../components/Alert.js";
import { useTranslation } from "react-i18next";
const SalaryDetailsDrawer = ({ open, onClose, data }) => {
  const { t } = useTranslation();
  console.log(data);
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: 530,
          maxWidth: "100%",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 10,
          backgroundColor: "#E7EBEE",
          p: 1.3,
          borderBottom: "1px solid #E0E0E0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.2 }}>
          <IconButton onClick={onClose}>
            <img src={profilecross} alt="close" />
          </IconButton>
          <CustomText
            sx={{
              ...textStyles.h1,
              fontSize: 20,
              fontWeight: 600,
              color: "#2C384C",
            }}
          >
            {t("salaryManagement.monthlySalary")}
          </CustomText>
        </Box>
      </Box>

      {/* Body */}
      <Box sx={{ p: 2, overflowY: "auto", flexGrow: 1 }}>
        {/* Status & Date */}
        <Box
          sx={{
            border: "1px solid #E4E6EF",
            borderRadius: 2,
            px: 2,
            py: 1,
            mb: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
              mt: 1,
            }}
          >
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 16,
                fontWeight: 400,
                color: "#5E5C5C",
                textAlign: "left",
              }}
            >
              {t("salaryManagement.status")}
            </CustomText>

            <Box
              sx={{
                backgroundColor: "#4BCE97",
                color: "#164B35",
                px: 2,
                py: 0.5,
                borderRadius: "4px",
                fontSize: "13px",
                fontWeight: 500,
                fontFamily: "Poppins, sans-serif",
              }}
            >
              {t("statuses.Paid")}
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 16,
                fontWeight: 400,
                color: "#5E5C5C",
                textAlign: "left",
              }}
            >
              {t("salaryManagement.date")}
            </CustomText>
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 15,
                fontWeight: 400,
                color: "#172B4D",
                textAlign: "left",
              }}
            >
              22 June, 2025{" "}
            </CustomText>{" "}
          </Box>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <CustomText
            sx={{
              ...textStyles.h1,
              fontSize: 18,
              fontWeight: 600,
              color: "#000000",
              textAlign: "left",
            }}
          >
            {t("salaryManagement.paymentDetails")}
          </CustomText>
          <img src={down} width={40} height={30} />
        </Box>

        <Box
          sx={{
            p: 2,
            overflowY: "auto",
            flexGrow: 1,
            border: "1px solid #E4E6EF",
            borderRadius: 2,
            px: 2,
            py: 2,
            mt: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 16,
                fontWeight: 400,
                color: "#5E5C5C",
                textAlign: "left",
              }}
            >
              {t("salaryManagement.workerName")}
            </CustomText>
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 15,
                fontWeight: 400,
                color: "#172B4D",
                textAlign: "left",
              }}
            >
              John Doe
            </CustomText>{" "}
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 16,
                fontWeight: 400,
                color: "#5E5C5C",
                textAlign: "left",
              }}
            >
              {t("salaryManagement.paidAmount")}
            </CustomText>
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 15,
                fontWeight: 400,
                color: "#172B4D",
                textAlign: "left",
              }}
            >
              $120
            </CustomText>{" "}
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 16,
                fontWeight: 400,
                color: "#5E5C5C",
                textAlign: "left",
              }}
            >
              {t("salaryManagement.remainingAmount")}
            </CustomText>
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 15,
                fontWeight: 400,
                color: "#172B4D",
                textAlign: "left",
              }}
            >
              $0
            </CustomText>{" "}
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 16,
                fontWeight: 400,
                color: "#5E5C5C",
                textAlign: "left",
              }}
            >
              {t("salaryManagement.method")}
            </CustomText>
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 15,
                fontWeight: 400,
                color: "#172B4D",
                textAlign: "left",
              }}
            >
              Cheque
            </CustomText>{" "}
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 16,
                fontWeight: 400,
                color: "#5E5C5C",
                textAlign: "left",
              }}
            >
              {t("salaryManagement.description")}
            </CustomText>
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 15,
                fontWeight: 400,
                color: "#172B4D",
                textAlign: "right",
              }}
            >
              Salary was handover using Cheque as there were a bank issue due to
              which salary was delaying
            </CustomText>{" "}
          </Box>
        </Box>

        {/* Recipe Box (Optional) */}

        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mb={1}
          sx={{ mt: 2 }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 18,
                fontWeight: 600,
                color: "#000000",
                textAlign: "left",
              }}
            >
              {t("salaryManagement.receipt")}
            </CustomText>
            <img src={down} width={40} height={30} />
          </Box>

          <Box>
            <img src={receipt} style={{ width: 30, height: 30 }} />
          </Box>
        </Box>

        <Box
          sx={{
            p: 2,
            overflowY: "auto",
            flexGrow: 1,
            border: "1px solid #E4E6EF",
            borderRadius: 2,
            px: 2,
            py: 2,
            mt: 2,
          }}
        >
          <img src={view} style={{ width: "100%", height: "auto" }} />
        </Box>

        <Box display="flex" gap={1} sx={{ mt: 2 }}>
          <CustomButton
            onClick={showUnderDevelopment}
            label={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <DeleteIcon sx={{ fontSize: 16 }} />
                {t("salaryManagement.delete")}
              </Box>
            }
            sx={{
              backgroundColor: "#FF6B6B",
              color: "#fff",
              borderRadius: "4px",
              fontSize: 14,
              textTransform: "none",
              px: 2,
              "&:hover": {
                backgroundColor: "#FF6B6B", // prevent color change on hover
              },
            }}
          />

          <CustomButton
            onClick={showUnderDevelopment}
            label={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <EditIcon sx={{ fontSize: 16 }} />
                {t("salaryManagement.edit")}
              </Box>
            }
            sx={{
              backgroundColor: "#006EC2",
              color: "#fff",
              borderRadius: "4px",
              fontSize: 14,
              textTransform: "none",
              px: 2,
            }}
          />
        </Box>
      </Box>
    </Drawer>
  );
};

export default SalaryDetailsDrawer;
